export const GET_ALL_STAFF = `GET_ALL_STAFF`;
export const SET_STAFFS = `SET_STAFFS`;

export const CREATE_STAFF_REQUEST = `CREATE_STAFF_REQUEST`;
export const CREATE_STAFF_SUCCESS = `CREATE_STAFF_SUCCESS`;

export const UPDATE_STAFF_REQUEST = `UPDATE_STAFF_REQUEST`;
